import React, {useState} from 'react';
import {scrollTo} from "../../../service/ToolsService";
import {NavLink} from "react-router-dom";
import {member} from "../../../models/member";
import DateService from "../../../service/DateService";
import {DeleteConfirme} from "../DeleteConfirme";
import {ApiService} from "../../../service/ApiService";
import {TableLineLoader} from "../../front/loader/TableLineLoader";

type MemberListProps = {
  members: member[],
  loading?: boolean,
  refresh: () => void,
}

export const MemberList = ({members, loading, refresh}: MemberListProps) => {
  const [del, setDel] = useState(undefined as undefined | member);

  const deleteMember = async (member: member) => {
    await ApiService.delete(`/member/${member.memberId}`);
    refresh();
  };

  return (
    <>
      <table className="table table-responsive table-hover border">
        <thead>
        <tr className="table-primary">
          <th>Nom</th>
          <th>Email</th>
          <th className="text-center w100px">Photo</th>
          <th className="text-center w100px">Poste</th>
          <th className="text-center w150px">Modification</th>
          <th className="w190px">{loading ? 'oui' : 'non'}</th>
        </tr>
        </thead>
        <tbody>
        {loading && (
          <tr>
            <td colSpan={6} className="pt-4 pb-4 ps-5 pe-5">
              <TableLineLoader/>
            </td>
          </tr>
        )}
        {!loading && members.map((member: member, index: number) => (
          <tr key={index}>
            <td>
              {member.firstname} {member.name}
            </td>
            <td>{member.email ?? '~'}</td>
            <td className="text-center">{member.avatar && (<i className="fa-regular fa-image"/>)}</td>
            <td className="text-center">
              {member.post.length}
            </td>
            <td className="text-center">
              {DateService
                .toLocaleString(member.updatedAt ?? member.createdAt, {day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false})
              }
            </td>
            <td className="text-end">
              <NavLink to={`/admin/office/member/edit/${member.memberId}`} onClick={scrollTo} className="btn btn-xs btn-primary me-1">
                <i className="fa-solid fa-pencil me-1"/> modifier
              </NavLink>
              <button className="btn btn-xs btn-danger" onClick={() => setDel(member)}><i className="fa-solid fa-xmark me-1"/>supprimer</button>
            </td>
          </tr>
        ))}
        </tbody>
      </table>

      {del && (
        <DeleteConfirme confirme={(c: boolean) => {
          if (c) {
            deleteMember(del);
          }

          setDel(undefined);
        }}/>
      )}
    </>
  )
}
